var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerformance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.17391 18.9129V14.1303C2.17391 13.53 1.68727 13.0433 1.08696 13.0433C0.486647 13.0433 0 13.53 0 14.1303V18.9129C0 19.5132 0.486647 19.9999 1.08696 19.9999C1.68727 19.9999 2.17391 19.5132 2.17391 18.9129Z",
    style: {
      fill: "var(--color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39169 18.9129V9.78251C7.39169 9.1822 6.90504 8.69556 6.30473 8.69556C5.70442 8.69556 5.21777 9.1822 5.21777 9.78251V18.9129C5.21777 19.5133 5.70442 19.9999 6.30473 19.9999C6.90504 19.9999 7.39169 19.5133 7.39169 18.9129Z",
    style: {
      fill: "var(--color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6085 18.913V5.43473C12.6085 4.83443 12.1218 4.34778 11.5215 4.34778C10.9212 4.34778 10.4346 4.83443 10.4346 5.43474V18.913C10.4346 19.5133 10.9212 20 11.5215 20C12.1218 20 12.6085 19.5133 12.6085 18.913Z",
    style: {
      fill: "var(--color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8258 18.913V1.08696C17.8258 0.486647 17.3391 0 16.7388 0C16.1385 0 15.6519 0.486647 15.6519 1.08696V18.913C15.6519 19.5134 16.1385 20 16.7388 20C17.3391 20 17.8258 19.5134 17.8258 18.913Z",
    style: {
      fill: "var(--color, currentColor)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.6afd1a7f.svg";
export { ForwardRef as ReactComponent };